<template>
  <div>
    <nav-bar></nav-bar>
    <!-- <div class="w-full h-full z-50 fixed bg-black" :class="{'hidden': ready}"></div> -->
    <router-view @isReady="ready = $event"/>
  </div>
</template>

<script>
import NavBar from './components/NavBar';

export default {
  components: {
    NavBar
  },
  data() {
    return {
      ready: false
    }
  },
  watch: {
    ready: () => {
      //alert('hoho')
    }
  }
}
</script>

<style>
* {
  @apply font-body;
}

.button-back:active {
  background: #000;
  color: #fff
}

.button-direction {
  @apply w-10 h-10 rounded mx-4 border-2 border-teal-500;
}

.button-direction:hover,
.button-direction:hover i {
  @apply bg-teal-500 text-white;
}

.button-action:focus,
.button-direction:focus {
  outline: none;
}

.button-action:active:not([disabled]),
.button-direction:active,
.button-plusmin:active:not([disabled]) {
  box-shadow: 2px 2px rgba(0,0,0,0.2);
}

.button-action:hover:not([disabled]) {
  @apply bg-teal-500 text-white;
}

.button-plusmin:hover:not([disabled]) {
  @apply bg-teal-500 text-white;
}

button:disabled {
  background: #808080;
  color: #fff
}

.shadows {
  /* box-shadow: 3px 3px #f50006;
  z-index: 100;
  display: inline-block;
  transform: translateZ(-100px) */
  background: #f50006
}
</style>
